import React from "react";
import { Navbar } from "../header";
import { Footer } from "../footer";
import "./PortfolioPage.css";

export const WeddingPortfolio = () => {
  const galleryImages = [
    {
      id: 1,
      src: "/resources/images/wedding/wedding-portfolio1.jpg",
      category: "Traditional",
      title: "Royal Indian Wedding"
    },
    {
      id: 2,
      src: "/resources/images/wedding/wedding-portfolio2.jpg",
      category: "Candid",
      title: "Precious Moments"
    },
    {
      id: 3,
      src: "/resources/images/wedding/wedding-portfolio3.jpg",
      category: "Ceremony",
      title: "Sacred Rituals"
    },
    {
      id: 4,
      src: "/resources/images/wedding/wedding-portfolio4.jpg",
      category: "Couple",
      title: "Love in Focus"
    },
    {
      id: 5,
      src: "/resources/images/wedding/wedding-portfolio5.jpg",
      category: "Traditional",
      title: "Cultural Elegance"
    },
    {
      id: 6,
      src: "/resources/images/wedding/wedding-portfolio6.jpg",
      category: "Reception",
      title: "Celebration of Love"
    },
    {
      id: 7,
      src: "/resources/images/wedding/wedding-portfolio7.jpg",
      category: "Details",
      title: "Wedding Finesse"
    },
    {
      id: 8,
      src: "/resources/images/wedding/wedding-portfolio8.jpg",
      category: "Family",
      title: "Family Moments"
    },
    {
      id: 9,
      src: "/resources/images/wedding/wedding-portfolio9.jpg",
      category: "Candid",
      title: "Natural Emotions"
    },
    {
      id: 10,
      src: "/resources/images/wedding/wedding-portfolio10.jpg",
      category: "Ceremony",
      title: "Sacred Bonds"
    },
    {
      id: 11,
      src: "/resources/images/wedding/wedding-portfolio11.jpg",
      category: "Couple",
      title: "Forever Together"
    },
    {
      id: 12,
      src: "/resources/images/wedding/wedding-portfolio12.jpg",
      category: "Traditional",
      title: "Timeless Traditions"
    },
    {
      id: 13,
      src: "/resources/images/wedding/wedding-portfolio13.jpg",
      category: "Ceremony",
      title: "Sacred Vows"
    },
    {
      id: 14,
      src: "/resources/images/wedding/wedding-portfolio14.jpg",
      category: "Couple",
      title: "Eternal Love"
    },
    {
      id: 15,
      src: "/resources/images/wedding/wedding-portfollio15.jpg",
      category: "Reception",
      title: "Celebration of Unity"
    },
    {
      id: 16,
      src: "/resources/images/wedding/wedding-portfolio16.jpg",
      category: "Candid",
      title: "Pure Emotions"
    },
    {
      id: 17,
      src: "/resources/images/wedding/wedding-portfolio17.jpg",
      category: "Details",
      title: "Wedding Elegance"
    },
    {
      id: 18,
      src: "/resources/images/wedding/wedding-portfolio18.jpg",
      category: "Family",
      title: "Cherished Bonds"
    },
    { id: 19, src: "/resources/images/wedding/wedding-portfolio19.jpg", category: "Ceremony", title: "Joyful Traditions" },
    { id: 20, src: "/resources/images/wedding/wedding-portfolio20.jpg", category: "Candid", title: "Unscripted Emotions" },
    { id: 21, src: "/resources/images/wedding/wedding-portfolio21.jpg", category: "Reception", title: "Grand Celebration" },
    { id: 22, src: "/resources/images/wedding/wedding-portfolio22.jpg", category: "Details", title: "Elegant Details" },
    { id: 23, src: "/resources/images/wedding/wedding-portfolio23.jpg", category: "Family", title: "Generations Together" },
    { id: 24, src: "/resources/images/wedding/wedding-portfolio24.jpg", category: "Couple", title: "Together Forever" },
    { id: 25, src: "/resources/images/wedding/wedding-portfolio25.jpg", category: "Traditional", title: "Cultural Heritage" },
    { id: 26, src: "/resources/images/wedding/wedding-portfolio26.jpg", category: "Ceremony", title: "Sacred Promises" },
    { id: 27, src: "/resources/images/wedding/wedding-portfolio27.jpg", category: "Candid", title: "Heartfelt Moments" },
    { id: 28, src: "/resources/images/wedding/wedding-portfolio28.jpg", category: "Reception", title: "Evening Festivities" },
    { id: 29, src: "/resources/images/wedding/wedding-portfolio29.jpg", category: "Details", title: "Artful Arrangements" },
    { id: 30, src: "/resources/images/wedding/wedding-portfolio30.jpg", category: "Family", title: "Bonded by Love" },
    { id: 31, src: "/resources/images/wedding/wedding-portfolio31.jpg", category: "Couple", title: "Shared Dreams" },
    { id: 32, src: "/resources/images/wedding/wedding-portfolio32.jpg", category: "Traditional", title: "Classic Beauty" },
    { id: 33, src: "/resources/images/wedding/wedding-portfolio33.jpg", category: "Ceremony", title: "Blessed Union" },
    { id: 34, src: "/resources/images/wedding/wedding-portfolio34.jpg", category: "Candid", title: "Genuine Smiles" },
    { id: 35, src: "/resources/images/wedding/wedding-portfolio35.jpg", category: "Reception", title: "Dancing Moments" },
    { id: 36, src: "/resources/images/wedding/wedding-portfolio36.jpg", category: "Details", title: "Finishing Touches" },
    { id: 37, src: "/resources/images/wedding/wedding-portfolio37.jpg", category: "Family", title: "Warm Embraces" },
    { id: 38, src: "/resources/images/wedding/wedding-portfolio38.jpg", category: "Couple", title: "Endless Love" },
    { id: 39, src: "/resources/images/wedding/wedding-portfolio39.jpg", category: "Traditional", title: "Graceful Moments" },
    { id: 40, src: "/resources/images/wedding/wedding-portfolio40.jpg", category: "Ceremony", title: "Sacred Blessings" },
    { id: 41, src: "/resources/images/wedding/wedding-portfolio41.jpg", category: "Candid", title: "Laughter & Joy" },
    { id: 42, src: "/resources/images/wedding/wedding-portfolio42.jpg", category: "Reception", title: "Evening Elegance" },
    { id: 43, src: "/resources/images/wedding/wedding-portfolio43.jpg", category: "Details", title: "Ornate Decor" },
    { id: 44, src: "/resources/images/wedding/wedding-portfolio44.jpg", category: "Family", title: "Family Gatherings" }
  ];

  return (
    <div className="portfolio-detail-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="portfolio-detail-hero">
        <h1 className="detail-hero-title">Wedding Photography</h1>
        <div className="title-line"></div>
        <p className="detail-hero-subtitle">Capturing Love Stories in Their Most Beautiful Light</p>
      </section>

      {/* Introduction */}
      <section className="portfolio-intro">
        <div className="intro-content">
          <h2>Our Wedding Photography</h2>
          <p>At Stories by Kalakaar, we believe every wedding is unique and deserves to be captured in its authentic essence. Our approach combines photojournalistic storytelling with artistic vision to create timeless memories of your special day.</p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="portfolio-gallery">
        <div className="gallery-grid">
          {galleryImages.map((image) => (
            <div key={image.id} className="gallery-item">
              <div className="image-wrapper">
                <img src={image.src} alt={image.title} />
                <div className="image-overlay">
                  <div className="image-info">
                    <span className="image-category">{image.category}</span>
                    <h3 className="image-title">{image.title}</h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section className="portfolio-services">
        <div className="services-content">
          <h2>Our Wedding Services</h2>
          <div className="services-grid">
            <div className="service-item">
              <h3>Pre-Wedding Shoots</h3>
              <p>Romantic sessions that tell your love story</p>
            </div>
            <div className="service-item">
              <h3>Wedding Ceremony</h3>
              <p>Complete coverage of your special day</p>
            </div>
            <div className="service-item">
              <h3>Reception</h3>
              <p>Capturing the joy of celebration</p>
            </div>
            <div className="service-item">
              <h3>Cinematic Films</h3>
              <p>Beautiful wedding films that tell your story</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="portfolio-cta">
        <div className="cta-content">
          <h2>Ready to Capture Your Special Day?</h2>
          <p>Let's create beautiful memories together</p>
          <a href="/contactUs" className="cta-button">Get in Touch</a>
        </div>
      </section>

      <Footer />
    </div>
  );
}; 